export default __webpack_public_path__ + "static/media/664AA066-5770-49FB-AB1F-9E3CBAC3422C_1_105_c.e97e3ea0.jpeg";